export const IMAGE_CONTROL = 'IMAGE_CONTROL';
export const IMAGE_DRAG = 'IMAGE_DRAG';



/** WEBPACK FOOTER **
 ** ../src/widgets/components/interactive/topScorersMulti/constants/index.js
 **/